import { render, staticRenderFns } from "./InventarioTableEstandarizados.vue?vue&type=template&id=36357df7&scoped=true&"
import script from "./InventarioTableEstandarizados.vue?vue&type=script&lang=js&"
export * from "./InventarioTableEstandarizados.vue?vue&type=script&lang=js&"
import style0 from "./InventarioTableEstandarizados.vue?vue&type=style&index=0&id=36357df7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36357df7",
  null
  
)

component.options.__file = "InventarioTableEstandarizados.vue"
export default component.exports